import BaseModel from './base-model';
/**
 * format:
 * @COMMON_NAME: "ALMONTE"
 * @REL_ATTR: "U'01ACDAB5544B01DE90B6001CC416E56E'"
 * @id: "U'01ACDAB5544B01DE90B6001CC416E56E'"
 */
export default class Location extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.zonabasica = opts.zonabasica || null;
  }
}
